import { ReactNode, FC, useState, useEffect } from 'react'
import {
  Box,
  VStack,
  Text,
  useColorMode,
  Button,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Center,
} from '@chakra-ui/react'
import DAppLayout from '../dApp/layouts/DAppLayout'
import { XpBar } from './components/XpBar'
import { GemCard } from './components/GemCard'
import { BadgesCard } from './components/BadgesCard'
import { ContentTabs } from './components/ContentTabs'
import { useUserByWalletInRouter } from '../techRaffles/hooks/user'
import { useWallet } from '@solana/wallet-adapter-react'
import { WalletMultiButton } from '../../components/wallet-ui'
import { useUser } from '../common/auth/authHooks'
import WeeklyRewards from './screens/WeeklyRewards'
import MyRewards from './screens/MyRewards'
import RunningPointMultipliersView from './screens/RunningPointsMultipliersView'
import NextLink from 'next/link'
import PastRewards from './screens/PastRewards'

export const DAppRewardsCenter = () => {
  const { colorMode } = useColorMode()
  const isDarkMode = colorMode === 'dark'

  const { publicKey } = useWallet()

  const { data: user, isLoading } = useUser()

  // useEffect(() => {
  //   console.log('user', user)
  // }, [user])

  const [activeTab, setActiveTab] = useState('Weekly Rewards')

  if (!publicKey) {
    return (
      <DAppLayout>
        <Center mt='15rem'>
          <VStack
            alignItems='center'
            justifyContent='center'
            maxWidth='500px'
            gap='10'
          >
            <Text>Connect Wallet to get started earning Rewards!</Text>
            <WalletMultiButton variant='normal' />
          </VStack>
        </Center>
      </DAppLayout>
    )
  }
  return (
    <DAppLayout>
      {/* <RewardsModal /> */}
      {/* <RewardsLevelUpModal /> */}
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Stack
          direction={['column', 'column', 'row']}
          bgColor={isDarkMode ? 'cardBlack' : '#FAFAFA'}
          display={'flex'}
          justifyContent={'space-between'}
          w='full'
          border='solid'
          borderColor={isDarkMode ? '#494949' : '#E9E9E9'}
          borderRadius='40px'
          padding='10'
          mb='10'
          spacing='1rem'
        >
          <VStack alignItems='flex-start' maxW='750px' spacing='1rem'>
            <Text fontSize='32' fontWeight='bold'>
              Rewards Center
            </Text>
            <Text display={['none', 'block', 'block']}>
              <b>
                Simply by participating and hosting raffles, you earn Gems and
                Lifetime Points.
              </b>{' '}
              <br />
              <br></br>
              <b>Gems can be spent</b> on our reward raffles seen below to win
              incredible prizes like all kinds of NFTs, SOL or USDC. You can
              almost see it as a 2nd chance, simply enter raffles, earn gems and
              be able to enter more raffles with your gems.
              <br></br>
              <br></br>
              <b>Lifetime points</b> define <b>your level</b>, which is shown to
              the whole community on Monet when you host a raffle and might come
              with special benefits in the future. So check out the raffles
              below and spend your gems wisely.
            </Text>
            <Text display={['block', 'none', 'none']}>
              <b>
                Simply by participating and hosting raffles, you earn Gems and
                Lifetime Points.
              </b>{' '}
              <br />
              <br></br>
              <b>Gems can be spent</b> on our reward raffles seen below to win
              all kinds of prizes.
              <br></br>
              <br></br>
              <b>Lifetime points</b> define <b>your level</b>, which is shown to
              the whole community on Monet when you host a raffle.
            </Text>
            <NextLink href='/rewards'>
            <Button variant={'secondaryOnGrey'}>
              Learn more
            </Button>
            </NextLink>
          </VStack>
          <VStack w='full' maxWidth={['full', 'full', '500px']}>
            <Stack
              direction={['column', 'row', 'row']}
              alignContent='stretch'
              justifyContent={['center']}
              w='full'
              h='full'
            >
              <GemCard />
              <XpBar variant='user' />
            </Stack>
            <BadgesCard
              h='75px'
              stackProps={{}}
              variant='user'
              badges={user?.badges}
              isLoading={isLoading}
            />
          </VStack>
        </Stack>
        <ContentTabs
          tabs={['Weekly Rewards', 'My Rewards', 'Past rewards', 'Point multipliers']}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        {activeTab === 'Weekly Rewards' && <WeeklyRewards userId={user?.id} />}
        {activeTab === 'My Rewards' && <MyRewards userId={user?.id}  />}
        {activeTab === 'Point multipliers' && <RunningPointMultipliersView />}
        {activeTab === 'Past rewards' && <PastRewards userId={user?.id} />}
      </Box>
    </DAppLayout>
  )
}
